<template>
    <div>
        <div class="card">

            <div class="">
                <TitleButton
                    title=""
                    :showAddNew="true"
                    btnTitle="Add new"
                    :showBtn="false"
                    @onClickAddNewButton="onClickToAppointment"
                />
            </div>

            <div class="my-2 px-1">
                <DateQuerySetter
                    btnTitle="Go"
                    @onClickGo="onClickGo"
                >
                    <div v-if="activeTabId === 'new_appointment'" class="col-12 col-sm-6 col-md-5 col-lg-4">
                        <label for="colFormLabel" class="col-form-label">Consultant</label>
                        <AsyncSelect
                            placeholder="Select consultant"
                            v-model="consultant"
                            :api-service="fetchServiceList"
                            :additional-query="{ resource_type: 'human_resources' }"
                            :format-label="formatPatientLabel"
                        />
                    </div>
                    <div v-else class="col-12 col-sm-6 col-md-5 col-lg-4">
                        <label for="colFormLabel" class="col-form-label">Doctor</label>
                        <AsyncSelect
                            placeholder="Select Doctor"
                            v-model="doctor"
                            :api-service="fetchContactProfiles"
                            :additional-query="{roles: 'doctor,medical_officer'}"
                            :format-label="formatPatientLabel"
                        />
                    </div>
                    <div class="col-12 col-sm-6 col-md-5 col-lg-4">
                        <label for="colFormLabel" class="col-form-label">Patient</label>
                        <AsyncSelect
                            placeholder="Patient Name, ID, Mobile No"
                            v-model="patient"
                            :api-service="fetchContactProfiles"
                            :additional-query="additionalQuery"
                            :format-label="formatPatientLabel"
                        />
                    </div>
                    <div class="col-12 col-sm-5 col-md-5 col-lg-2">
                        <label for="colFormLabel" class="col-form-label">Patient ID</label>
                        <vField
                            v-model="serialNo"
                            name="serial"
                            type="number"
                            class="form-control"
                            placeholder="Patient ID"
                        />
                    </div>
                </DateQuerySetter>
            </div>

            <div class="row px-2">
                <div class="col-6"></div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <AppointmentNav 
                        @setActiveTabId="setActiveTabId"
                    />
                </div>
            </div>

            <Transition name="tab-fade" mode="out-in">
                <NewAppointment
                    :patientId="patient ? patient.id : null"
                    :serialNo="serialNo"
                    :consultantId="consultant ? consultant.id : null"
                    v-if="activeTabId === 'new_appointment'"
                    ref="appointmentRef"
                />
            </Transition>

            <Transition name="tab-fade" mode="out-in">
                <OngoingTreatment
                    :patientId="patient ? patient.id : null"
                    :serialNo="serialNo"
                    :doctorId="doctor ? doctor.id : null"
                    v-if="activeTabId === 'ongoing_treatment'"
                    ref="ongoingTreatmentRef"
                />
            </Transition>

        </div>
    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue';
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import {inject, ref} from "vue";
import {useStore} from "vuex";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleContact from "@/services/modules/contact";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import handleHospital from "@/services/modules/hospital";
import AppointmentNav from "@/components/molecule/company/dental-os/single-service/appointment/components/AppointmentNav.vue";
import NewAppointment from '@/components/molecule/company/dental-os/single-service/appointment/NewAppointment.vue';
import OngoingTreatment from '@/components/molecule/company/dental-os/single-service/appointment/OngoingTreatment.vue';

const store = useStore();

const {fetchContactProfiles} = handleContact()
const {formatPatientLabel} = useAsyncDropdownHelper();
const { fetchServiceList } = handleHospital();

const patient = ref(null);
const consultant = ref(null);
const serialNo = ref(null);
const doctor = ref(null);

const activeTabId = ref('new_appointment');
const appointmentRef = ref(null);
const ongoingTreatmentRef = ref(null);

const setActiveTabId = (id) => {
    activeTabId.value = id;
}

const onClickGo = () => {
    if (activeTabId.value === 'new_appointment' && appointmentRef.value) {
        appointmentRef.value.getOPDBillings();
    } else if (activeTabId.value === 'ongoing_treatment' && ongoingTreatmentRef.value) {
        ongoingTreatmentRef.value.getDentalScheduleList();
    }
}

const additionalQuery = {
    type: "patient"
}

const onClickToAppointment = () => {
    store.state.isModalOpen = true
}

</script>